import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import $ from 'jquery';

if( $( '[data-fadein]' ).length || $( '[data-fadeup]' ).length || $( '[data-scalein]' ).length ) {
  gsap.registerPlugin( ScrollTrigger );
}

if ( $( '[data-fadeup]' ).length ) {
  let fadeIn = document.querySelectorAll( "[data-fadeup]" );

  fadeIn.forEach( ( elem, i ) => {
    gsap.set( fadeIn, {
      opacity: 0,
      transform: 'translateY( 10% )'
    } );

    ScrollTrigger.create( {
      trigger: elem,
      start: "center 75%",

      onEnter: () => gsap.to( elem, {
        opacity: 1,
        transform: 'translateY( 0 )',
        overwrite: 'auto'
      }),
    });
  });
}

if ( $( '[data-fadein]' ).length ) {
  let fadeIn = document.querySelectorAll( "[data-fadein]" );

  fadeIn.forEach( ( elem, i ) => {
    gsap.set( fadeIn, { opacity: 0, } );

    ScrollTrigger.create( {
      trigger: elem,
      start: "center 75%",

      onEnter: () => gsap.to( elem, {
        opacity: 1,
        overwrite: 'auto'
      }),
    });
  });
}

if ( $( '[data-scalein]' ).length ) {
  let scaleIn = document.querySelectorAll( "[data-scalein]" );

  scaleIn.forEach( ( elem, i ) => {
    gsap.set( scaleIn, {
      transform: 'scale(0.85)',
      Transition: 'ease-in'
    });

    ScrollTrigger.create( {
      trigger: elem,
      start: "center 75%",

      onEnter: () => gsap.to( elem, {
        transform: 'scale(1)',
        overwrite: 'auto'
      } ),
    });
  });
}
